module.exports = __webpack_public_path__ + "img/CityOfHashibi.739e6983.png";